import React from "react";

interface SheetFooterProps {
  children: React.ReactNode;
}

export default function SheetFooter({ children }: SheetFooterProps) {
  return (
    <div className="shrink-0 w-full bg-[var(--color-white)] px-4 py-3 shadow-[0_-2px_8px_rgba(0,0,0,0.06)] z-10">
      {children}
    </div>
  );
}
